<template>
	<div class="bright container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0" >
			<div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12">
						<h4>OVERVIEW CAFE</h4>
					</div>
				</div>
			</div>

			<div class="col-md-8">
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SALES" unit="M" div=1000000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="LOSSES" unit="Jt" div=1000000 :data="ytd.losses.rekap" itemcol="Info" valuecol="Value" comp=-1 url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SALES PER DAY" unit="Jt" div=1000000 :data="ytd.sales.spd" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<BarCard title="SALES YTD (M)" :data="ytd.sales.ytdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES MTD (M)" :data="ytd.sales.mtdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN YTD (%)" :data="ytd.margin.ytdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="MARGIN MTD (%)" :data="ytd.margin.mtdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
				</div>				
			</div>
			<div class="col-md-4">
				<div class="row">
					<ListItem v-if="false" title="CAFE BY AREA" prefix="AREA" :data="store.area" itemcol="SalesArea" valuecol="StoreCnt"/>
					<ListItem title="CAFE BY REGION" prefix="REGION" :data="store.region" itemcol="RegionPertareId" valuecol="StoreCnt"/>
					<ListItem title="CAFE BY PROVINCE" :data="store.province" itemcol="ProvinceName" valuecol="StoreCnt"/>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import { Rainbow, Rainbow2, FuelColor, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: Cafe,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer            
	},
    mounted()
	{
		this.loadYTD();
		this.loadStore();
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'
    },
    methods:{
		async loadYTD() {
			let url = Config().apiURL + "/cafe/ytd-overview?" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				//console.log('ytd cafe: '+ JSON.stringify(result.data))
				if (result.data.sales.length) {
					let field = 'RegionPertareId' ; //SalesArea //RegionPertareId
					let prefix = 'REGION '; //AREA //REGION

					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "SalesExTax", "StoreCount", "Grup", 1, 2, false, false, "NumDay"),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, field, prefix, 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, field, prefix, 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", field, prefix, 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", field, prefix, 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", field, prefix, 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.losses = {
						rekap: this.processYTD(result.data.losses, "Info", "Losses", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, field, prefix, 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, field, prefix, 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
				
				}

				//console.log('ytd sales : ' + JSON.stringify(result.data.sales))
				//console.log('ytd sales cafe ALL: ' + JSON.stringify(this.ytd.sales.rekap))
				//console.log('ytd sales cafe: ' + JSON.stringify(this.ytd.sales.rekap[3]))

				//console.log('ytd losses cafe ALL: ' + JSON.stringify(this.ytd.losses.rekap))
			})
		},
	}
}

</script>